import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const TaskIcon = ({ boxSize, iconSize }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: boxSize,
        height: boxSize,
        borderRadius: '50%',
        backgroundColor: theme.palette.icon.tasks.background,
      }}
    >
      <TaskAltIcon
        sx={{
          color: theme.palette.icon.tasks.contrast,
          fontSize: iconSize,
        }}
      />
    </Box>
  );
};

export default TaskIcon;
